import React from 'react';
import Image from 'next/image';
import SEACBannerImg from '@/images/seac-banner.webp';
import './Error.scss';

type ErrorProps = Readonly<{ children: React.ReactNode; description: string; errorCode: string | number; title: string }>;

function ErrorMessage({ children, description, errorCode, title }: ErrorProps) {
	return (
		<div className="[ error ] [ w-full grid ]">
			<div className="[ error__details ] [ px-4 py-8 md:px-0 g-col-12 md:g-col-10 md:g-start-2 lg:g-col-5 lg:g-start-2 d-flex d-flex-column lg:justify-center gap-4 text-body-base ]">
				<header className="d-flex d-flex-column-reverse gap-2">
					{title && <h1 className="text-heading-1">{title}</h1>}
					{errorCode && <h4 className="text-heading-6">{errorCode}</h4>}
				</header>
				<p>{description}</p>
				{children}
			</div>
			<div className="[ error__image ] [ g-col-12 lg:g-col-5 lg:g-start-8 ]">
				<Image
					src={SEACBannerImg}
					width={1600}
					height={900}
					alt="A grey Toyota bZ4X driving through snowy mountains"
					className="[ w-full object-cover ]"
					priority={true}
					placeholder="blur"
				/>
			</div>
		</div>
	);
}

export { ErrorMessage as Error };
